/**
 * configurator API
 * configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Constraint } from './constraint';
import { DynamicOperand } from './dynamicOperand';
import {StaticOperand} from "./staticOperand";


export interface DeltaDateConstraint extends Constraint {
    delta: number;
    operand1: DynamicOperand;
    type: DeltaDateConstraint.TypeEnum;
}
export namespace DeltaDateConstraint {
    export type TypeEnum = 'HOUR' | 'DAY' | 'WEEK' | 'MONTH' | 'YEAR';
    export const TypeEnum = {
        HOUR: 'HOUR' as TypeEnum,
        DAY: 'DAY' as TypeEnum,
        WEEK: 'WEEK' as TypeEnum,
        MONTH: 'MONTH' as TypeEnum,
        YEAR: 'YEAR' as TypeEnum
    };
}
